export type ReportsTranslation = {
  contacts: {
    addedFromLabel: string;
    button: string;
    description: string;
    error: string;
    generating: string;
    title: string;
  };
};

export const reportsTranslation: ReportsTranslation = {
  contacts: {
    addedFromLabel: 'Kontakty dodane od (opcjonalnie)',
    button: 'Pobierz kontakty',
    description:
      'Wygeneruj i pobierz plik XLSX z kontaktami (e-mail kontaktu, klient, właściciel, ' +
      'data dodania i aktualizacji). Generowanie może chwilę potrwać — plik pobierze się ' +
      'automatycznie, gdy będzie gotowy.',
    error: 'Nie udało się wygenerować raportu kontaktów. Spróbuj ponownie.',
    generating: 'Generowanie raportu…',
    title: 'Raport kontaktów',
  },
};
